import styled from 'styled-components';

export const TopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
`;

export const TopBarInner = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const Logo = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  text-decoration: none;
`;

export const LogoMark = styled.span`
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 0.8rem;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.accent} 0%,
    ${({ theme }) => theme.colors.accentDark} 100%
  );
  color: ${({ theme }) => theme.colors.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.05rem;
`;

export const LogoWordmark = styled.span`
  font-size: 1.7rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  letter-spacing: -0.03rem;
`;

export const PromoCta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1.2rem;
  border-radius: 999rem;
  background-color: rgba(14, 165, 233, 0.1);
  color: ${({ theme }) => theme.colors.accent};
  font-size: 1.2rem;
  font-weight: 700;
  text-decoration: none;
  border: 0.1rem solid rgba(14, 165, 233, 0.32);
`;

export const Container = styled.div`
  max-width: 48rem;
  margin: 3.2rem auto;
  padding: 0 1.6rem;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.6rem;
  padding: 2.4rem;
`;

export const Header = styled.div`
  margin-bottom: 1.6rem;
`;

export const HeaderTitle = styled.div`
  font-size: 2.2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const ProviderName = styled.div`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.slate};
  margin-top: 0.4rem;
`;

export const ServiceName = styled.div`
  font-size: 1.3rem;
  font-style: italic;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.2rem;
`;

export const DateText = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateMuted};
  margin-top: 0.4rem;
`;

export const StatusRow = styled.div`
  margin-bottom: 2rem;
`;

export const Badge = styled.span<{ $type: string }>`
  display: inline-block;
  padding: 0.4rem 1.2rem;
  border-radius: 999rem;
  font-size: 1.2rem;
  font-weight: 700;
  background-color: ${({ $type, theme }) =>
    $type === 'completed'
      ? theme.colors.successBgSoft
      : $type === 'accepted'
        ? theme.colors.infoBg
        : $type === 'pending'
          ? theme.colors.amberBgSoft
          : theme.colors.errorBg};
  color: ${({ $type, theme }) =>
    $type === 'completed'
      ? theme.colors.successText
      : $type === 'accepted'
        ? theme.colors.info
        : $type === 'pending'
          ? theme.colors.amberText
          : theme.colors.errorDark};
`;

export const CancelledBox = styled.div`
  background-color: ${({ theme }) => theme.colors.errorBg};
  border: 0.1rem solid #fecaca;
  border-radius: 1.2rem;
  padding: 1.6rem 2rem;
`;

export const CancelledTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.errorDark};
  margin-bottom: 0.4rem;
`;

export const CancelledHint = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.errorDarkest};
  line-height: 1.5;
`;

export const CounterBox = styled.div`
  background-color: ${({ theme }) => theme.colors.amberBg};
  border: 0.1rem solid #fde68a;
  border-radius: 1.2rem;
  padding: 2rem;
  margin-bottom: 2rem;
`;

export const CounterTitle = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.amberText};
  font-weight: 600;
  margin-bottom: 0.8rem;
`;

export const CounterAmount = styled.div`
  font-size: 2.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.4rem;
`;

export const CounterOriginal = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: 1.6rem;
`;

export const CounterActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const AcceptBtn = styled.button`
  width: 100%;
  border: none;
  border-radius: 1rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.accentDark};
  cursor: pointer;
  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;

export const RejectBtn = styled.button`
  width: 100%;
  border: 0.1rem solid #fecaca;
  border-radius: 1rem;
  padding: 1.1rem 1.6rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.error};
  background-color: ${({ theme }) => theme.colors.errorBg};
  cursor: pointer;
`;

export const AgreedBox = styled.div`
  background-color: ${({ theme }) => theme.colors.successBg};
  border: 0.1rem solid #bbf7d0;
  border-radius: 1rem;
  padding: 1.2rem 1.6rem;
  margin-bottom: 2rem;
`;

export const AgreedText = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.successDark};
`;

export const CompletedBox = styled.div`
  text-align: center;
  padding: 2.4rem 1.6rem;
  background-color: ${({ theme }) => theme.colors.successBg};
  border-radius: 1.2rem;
  border: 0.1rem solid #bbf7d0;
`;

export const CompletedIcon = styled.div`
  font-size: 4rem;
  color: ${({ theme }) => theme.colors.success};
  margin-bottom: 0.8rem;
`;

export const CompletedTitle = styled.div`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.successDark};
  margin-bottom: 0.8rem;
`;

export const CompletedHint = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.successDarkest};
  line-height: 1.6;
`;

export const CodeSection = styled.div`
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding-top: 2rem;
`;

export const CodeSectionTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.6rem;
`;

export const CodeSectionHint = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-bottom: 1.6rem;
  line-height: 1.5;
`;

export const ErrorText = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 0.8rem;
`;

export const SubmitBtn = styled.button`
  width: 100%;
  border: none;
  border-radius: 1.2rem;
  padding: 1.4rem 1.6rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.accentDark};
  cursor: pointer;
  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.4rem;
  z-index: 50;
`;

export const Dialog = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: 2.4rem;
  max-width: 40rem;
  width: 100%;
`;

export const DialogTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 1.2rem;
`;

export const DialogBody = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.6;
  margin-bottom: 2.4rem;
`;

export const DialogActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const DialogCancelBtn = styled.button`
  width: 100%;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.slate};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
`;

export const DialogConfirmBtn = styled.button`
  width: 100%;
  border: none;
  border-radius: 1rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.error};
  cursor: pointer;
  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;
